import styled from "styled-components";
import { theme } from '../../theme'

export const StyledStepperContainer = styled.div`
/* margin: 0 auto; */
/* padding: 1rem 1rem; */
/* max-width: 730px; */
`
export const AccordionContainer = styled.div`
margin-top: 2.5rem;

.subject-title {
  color:${theme.colors.mainBlue};
  font-weight: 500;
  font-size: 1.4rem;
}

.css-1elwnq4-MuiPaper-root-MuiAccordion-root {
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.0293252);
  border-radius: 8px;

  .css-15v22id-MuiAccordionDetails-root {
    padding: 0;
  }
}

.subject-topic-container {
  display: flex;
  align-items: center;
  border-bottom: 1px solid rgba(216, 216, 216, 0.37);
  padding: 1rem 1.6rem;

    .subject-topic-main-text{
      display: flex;
      align-items: center;
      gap: 1.608rem;

      .check-icon {
      display: flex;
      align-items: center;
      color:${theme.colors.mainBlue};
      height: 1.5rem;
      width: 1.5rem;

      svg {
        height: 100%;
        width: 100%;
      }
    }
    .subject-topic {
      font-size: 1.2rem;
      color: #979797;
    }
  }

  .subject-topic-duration {
    margin-left: auto;
    font-size: 10px;
    color: #979797;
  }
  
  
}

`
export const RadioInputWrapper = styled.div`
  display: flex;
  align-items: center;
  
  color: #979797;

  .question-custom-radio-btn {
    line-height: 1.1;
    font-size: 1.2rem;
    display: flex;
    gap: 1rem;

    input[type="radio"] {
      appearance: none;
      background-color: none;
      margin: 0;
      color: ${theme.colors.black};
      width: 1.5rem;
      height: 1.5rem;
      border: 2px solid ${theme.colors.black};
      border-radius: 50%;
      transform: translateY(-0.075rem);
      display: grid;
      place-content: center;

      &::before {
        content: "";
        width: 0.65rem;
        height: 0.65rem;
        border-radius: 50%;
        transform: scale(0);
        transition: 120ms transform ease-in-out;
        box-shadow: inset 1rem 1rem ${theme.colors.mainBlue};
      }

      
    }
    input[type="radio"]:checked::before {
        transform: scale(1);
      }
  }

  label {
    margin-left: 1rem;
  }
`

export const StyledStepperWrapper = styled.div`
.c-stepper__item {
  position: relative;
  display: flex;
  gap: 1rem;
  padding-bottom: 4rem;

  &:before {
    content: attr(data-content);
    flex: 0 0 clamp(1.5rem, 5vw, 3rem);
    height: clamp(1.5rem, 5vw, 3rem);
    border-radius: 50%;
    border: 2px solid #DFE1E4;
    display: flex;
    align-items: center;
    justify-content:center;
    font-weight: 700;
    font-size: 1.6rem;
  }

  /* &:not(:last-child) { */
    &:after {
      content: "";
      position: absolute;
      left: 0;
      /* top: calc(clamp(1.5rem, 5vw, 3rem) + clamp(0.25rem, 2vw, 0.5rem));
      bottom: clamp(0.25rem, 2vw, 0.5rem); */
      top: clamp(1.5rem, 5vw, 3rem);
      bottom: 0;
      /* z-index: -1; */
      transform: translateX(calc(clamp(1.5rem, 5vw, 3rem) / 2));
      width: 2px;
      background-color: #DFE1E4;
    }
  /* } */
}

.c-stepper__title {
    font-weight: 700;
    font-size: 1.6rem;
  margin-bottom: clamp(0.85rem, 2vmax, 1rem);
}

.c-stepper__desc {
    font-size: 1.2rem;
    color: #979797;
    white-space: pre-line
}

.c-stepper__content {
  /* max-width: 700px; */
  .stepper-options {
    margin-top: 2.15rem;
    padding-left: 4rem;
  }
}
`